import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Home";

import Faq from "./home/Faq";
import ContactPage from "./home/ContactPage";
import SignUp from "./home/auth/SignUp";
import SignupPage from "./home/auth/SignUp";
import Login from "./home/auth/Login";
import ForgotPassword from "./home/ForgotPassword";
import IdeaSubmission from "./home/IdeaSubmission";
import StoryHome from "./home/stories/StoryHome";
import Post from "./home/stories/Post";
import StoryDetails from "./home/stories/ClickStory";
import ViewStory from "./home/stories/ViewStory";
import EditStory from "./home/stories/EditStory";
import Pitch from "./home/ratings&feedback/Pitch";

import InvestorProfile from "./home/investorProfile/investorProfile";
import UserProfile from "./home/editProfileInvestor/editProfile";

import PitchVideoPage from "./home/pitch/PitchVideoPage";
import StudentPitch from "./home/StudentAlumni/StudentPitch";
import AdminFaq from "./home/AdminFaq";

function IsInvestorOrNot({ children }) {
  const user = localStorage.getItem("user");
  const { role } = JSON.parse(user);
  if (role == "Investor") {
    return children;
  }
  return <div>USER NOT AUTHORIZED</div>;
}
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/idea-submission" element={<IdeaSubmission />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/story" element={<StoryHome />} />
        <Route path="/storyAdmin" element={<ViewStory />} />
        <Route path="/story/:id" element={<StoryDetails />} />
        <Route path="/postStory" element={<Post />} />
        <Route path="/viewStory" element={<ViewStory />} />
        <Route path="/viewStory/:id" element={<StoryDetails />} />
        <Route path="/editstory/:id" element={<EditStory />} />
        <Route
          path="/pitch"
          element={
            <IsInvestorOrNot>
              <Pitch />
            </IsInvestorOrNot>
          }
        />

        <Route path="/investorProfile" element={<InvestorProfile />} />
        <Route path="/editProfile" element={<UserProfile />} />

        <Route path="/pitch/:_id" element={<PitchVideoPage />} />
        <Route path="/studentAlumni" element={<StudentPitch />} />
        <Route path="/adminfaq" element={<AdminFaq />} />
      </Routes>
    </Router>
  );
}

export default App;
